import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../../lib/route-guard.js';

export const Route = createFileRoute('/integrations/leaflink')({
  // GET_LEAFLINK_COMPANIES/GET_LEAFLINK_COMPANY always request LeafLinkCompany.brand, which the
  // API gates on brand:view (every relation to Brand requires it, regardless of source model) --
  // without it the whole query errors out, so this route needs both permissions up front.
  component: () => <RouteGuard route="/integrations/leaflink" />,
});
